import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/api.model';

export interface IOrderDocumentLock {
  _id?: string;
  orderDocumentId: string;
  userId: string;
  employeeId: string;
  createdAt?: Date;
}

@Injectable({
  providedIn: 'root',
})
export class OrderDocumentLockService {
  private readonly apiUrl = `${environment.apiUrl}/order-document-lock`;

  constructor(private http: HttpClient) {}

  public createLock(orderDocumentId: string, employeeId: string): Observable<ApiResponse<IOrderDocumentLock>> {
    // userId is derived server-side from the JWT, not sent from here.
    return this.http.post<ApiResponse<IOrderDocumentLock>>(this.apiUrl, { orderDocumentId, employeeId });
  }

  public deleteLock(orderDocumentId: string): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${orderDocumentId}`);
  }

  public getLock(orderDocumentId: string): Observable<ApiResponse<IOrderDocumentLock | null>> {
    return this.http.get<ApiResponse<IOrderDocumentLock | null>>(`${this.apiUrl}/${orderDocumentId}`);
  }
}
